var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarkedMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3.75 8.08301L13.5 14.583L23.25 8.08301V21.083H3.75V8.08301Z",
    fill: "#9D60FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 6.99967V19.9997C2.6665 21.1968 3.63609 22.1663 4.83317 22.1663H22.1665C23.3636 22.1663 24.3332 21.1968 24.3332 19.9997V6.99967C24.3332 5.80259 23.3636 4.83301 22.1665 4.83301H4.83317C3.63609 4.83301 2.6665 5.80259 2.6665 6.99967ZM22.1665 19.9997H4.83317V6.99967H22.1665V19.9997Z",
    fill: "#9D60FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 9.57389L13.5 15.6666L23.25 9.57389V7.40723L13.5 13.4999L3.75 7.40723V9.57389Z",
    fill: "#9D60FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 10.25V18.9167L17.8332 16.75L15.6665 18.9167V13.5L19.9998 10.25Z",
    fill: "#9D60FB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkedMail);
export default __webpack_public_path__ + "static/media/markedMail.fe1452ba2f6607142d3a6c3491a4356f.svg";
export { ForwardRef as ReactComponent };